import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, Loader2, ArrowRight } from 'lucide-react';

import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('confirming'); // confirming, success

  useEffect(() => {
    // Stripe adds session_id to the URL after successful checkout
    const sessionId = searchParams.get('session_id');

    if (sessionId) {
      // Stripe webhook handles subscription activation automatically
      // Just show success after a brief moment to let webhook process
      const timer = setTimeout(() => {
        setStatus('success');
      }, 1500);
      return () => clearTimeout(timer);
    } else {
      // No session_id but still on success page - likely direct navigation
      setStatus('success');
    }
  }, [searchParams]);

  const goToDashboard = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-stone-50 to-stone-100 p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardContent className="py-12 text-center">
          {status === 'confirming' && (
            <>
              <Loader2 className="h-16 w-16 animate-spin text-amber-600 mx-auto mb-6" />
              <h2 className="text-xl font-semibold text-stone-800 dark:text-stone-200 mb-2">
                Setting Up Your Subscription
              </h2>
              <p className="text-stone-600 dark:text-stone-400">
                Please wait while we activate your membership...
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="h-12 w-12 text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-stone-800 dark:text-stone-200 mb-2">
                Welcome to Owaza!
              </h2>
              <p className="text-stone-600 dark:text-stone-400 mb-8">
                Your subscription is now active. Thank you for joining us!
              </p>
              <Button
                onClick={goToDashboard}
                variant="memberGold"
              >
                Go to Dashboard
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
              <p className="text-sm text-stone-500 dark:text-stone-400 mt-6">
                Questions? Contact us at{' '}
                <a href="mailto:info@owazamartialarts.com" className="text-amber-600 hover:underline">
                  info@owazamartialarts.com
                </a>
              </p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
